import React, { FC, PropsWithChildren } from 'react';

import { Toaster } from 'features/toaster/Toaster';
import { AiCompanionSidebar } from 'features/aiCompanion/AiCompanionSidebar';
import { AiCompanionSidebarProvider } from 'features/aiCompanion/AiCompanionSidebarContext';
import { NavbarCollapseProvider } from 'features/navbar/NavbarCollapseContext';
import auth from 'utils/auth';

import { InitialiseTracking } from './globalTracking/InitialiseTracking';
import { CatchErrors } from './globalErrorHandling/CatchErrors';
import { SetupGlobalState } from './globalStateInitialisation/SetupGlobalState';

export const RouteBootstrap: FC<PropsWithChildren> = ({ children }) => {
  return (
    <CatchErrors>
      <InitialiseTracking>
        <NavbarCollapseProvider>
          <Toaster>
            <SetupGlobalState>
              <AiCompanionSidebarProvider>
                {children}
                {auth.isLoggedIn() && <AiCompanionSidebar />}
              </AiCompanionSidebarProvider>
            </SetupGlobalState>
          </Toaster>
        </NavbarCollapseProvider>
      </InitialiseTracking>
    </CatchErrors>
  );
};
